import APP_ACTIONS from '../constants/app-actions';
import localStorageAPI from '../services/local-storage-api';

const locale = {
    setLocale: (locale) => (dispatch, getState) => {
        if (getState().locale.currentLocale !== locale && window.zE) {
            window.zE('webWidget', 'setLocale', locale);
        }
        dispatch({ type: APP_ACTIONS.SET_LOCALE, payload: { locale } });
        localStorageAPI.save(getState());
    },
};

export default locale;



/** WEBPACK FOOTER **
 ** ./src/actions/locale.js
 **/